(() => {
  class ScanwellMatchingTableController {
    constructor(ngDialog, Utils) {
      'ngInject';

      Object.assign(this, {
        ngDialog,
        Utils
      });
    }

    showDetails(result) {
      this.openScanwellMatchingForm(result, response => {
        if (response && response.success) {
          // Details updated
          // We need to refresh the list
          this.onPageChange();
        } else {// User closed the popup
          // Do nothing
        }
      });
    }

    openScanwellMatchingForm(result, callback) {
      return this.ngDialog.open({
        template: 'app/components/scanwell-matching-form/scanwell-matching-form.html',
        // To not allow the user closes the modal without explicitely to have some action
        // select the X to close
        // closeByEscape: false,
        // closeByNavigation: false,
        // closeByDocument: false,
        // To make possible doctor still be able to use the screen behind
        // overlay: false,
        controller: 'ScanwellMatchingFormController',
        controllerAs: '$ctrl',
        className: 'ngdialog-theme-default scanwell-matching-form-modal',
        data: {
          result: result
        },

        /**
         * @param {string|object} res - res will be an object if a pharmacy is selected
         */
        preCloseCallback(res) {
          if (typeof res === 'object') {
            return callback(res);
          }

          return callback(false);
        }

      });
    }

  }

  ScanwellMatchingTableController.$inject = ["ngDialog", "Utils"];
  angular.module('pims').component('scanwellMatchingTable', {
    templateUrl: 'app/components/scanwell-matching-table/scanwell-matching-table.html',
    controller: ScanwellMatchingTableController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      results: '<',
      lessColumns: '<'
    }
  });
})();